import logo from '@/assets/hiredcoach-logo.svg';
import React from "react";

const InterviewGradingWait: React.FC = () => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 animate-fade-in">
    <div className="bg-white dark:bg-card rounded-2xl shadow-xl p-12 max-w-2xl w-full flex flex-col items-center">
      <h1 className="flex items-center gap-2 text-xl text-primary font-semibold mb-2">We're reviewing your interview</h1>
      <img src={logo} alt="HiredCoach Logo" className="w-28 mb-4" />
      <div className="flex items-center gap-2 text-xl text-primary font-semibold mb-2">
        This might take a minute...
      </div>
      <div className="flex flex-col items-center">
        <svg className="animate-spin w-12 h-12 text-primary mb-2" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
        </svg>
        <span className="text-sm text-muted-foreground">Grading in progress...</span>
      </div>
      <div className="text-center text-muted-foreground mb-2 text-base space-y-2 mt-6">
        We're reviewing your answers against our industry research; but we're not just giving you a grade; we're also going to give you:
      </div>
      <ul className="text-left text-muted-foreground mb-4 text-lg list-disc list-inside space-y-2 mt-6">
        <li>Insight into what the hiring manager would be thinking</li>
        <li>Direct actionable feedback for your next interview</li>
        <li>A question by question break down to provide you with a <i>great</i> study guide</li>
      </ul>
    </div>
  </div>
);

export default InterviewGradingWait;
